import { useEffect, useRef, useState } from 'react'
import { useAuth } from '../hooks/getAuth'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ParcelDetail from '../components/ParcelDetail'
import { toast } from 'react-toastify'
import { callAPI } from '../hooks/api'
import Spinner from '../components/Spinner'
import RanchCardView from '../components/RanchCardView'
import { isMobile } from 'react-device-detect'
import MobileParcelDetail from '../components/MobileParcelDetail'
import { geojsonToWKT } from '@terraformer/wkt'
import { LuFileJson, LuFileText } from 'react-icons/lu'
import APNSuggestionModal from '../components/APNSuggestionModal'
import InfoPopup from '../components/InfoPopup'
import useAbility from '@/hooks/use-ability'
import UpgradeLayout from '@/components/upgrade-layout'
import { undefinedToZero } from '@/hooks/utils'

export default function Portfolio({
  clearRanchSelection,
  currentTab,
  setCurrentTab,
  ranches,
  setRanches,
  selectedRanch,
  setSelectedRanch,
  localAuth,
}) {
  const { checkAbility, invalidateQuery } = useAbility()

  const enableBulkUpload = checkAbility('bulk_upload')

  const removeStylesheet = (href) => {
    const link = document.querySelector(`link[href="${href}"]`)
    if (link) {
      document.body.removeChild(link)
    }
  }
  removeStylesheet('/css/landing.css')
  removeStylesheet('/css/bootstrap.css')
  const [searchParams] = useSearchParams()
  const isDemoUser =
    localAuth.sessionKey === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf'
  const [loading, setLoading] = useState(false)
  const { setAuth, setIsLoggedIn } = useAuth()
  const [ranchParcels, setRanchParcels] = useState({})
  const [updateSummary, setUpdateSummary] = useState(false)
  const [showAPNSuggestionModal, setShowAPNSuggestionModal] = useState(false)
  const textFileRef = useRef(null)
  const geomFileRef = useRef(null)

  const [popupContent, setPopupContent] = useState(null)
  const [reports, setReports] = useState([])
  const [summaries, setSummaries] = useState([])

  const [selectedProperty, setSelectedProperty] = useState({
    id: 8,
    data: {
      name: 'Test Orchard8',
      imgUrls: [
        'https://spacenews.com/wp-content/uploads/2017/09/venus-phoenix.jpg',
      ],
      timestamp: 1698160770000,
      address: '8718 Terra Bella CA',
      hydraScore: 83,
      offer: true,
      regularPrice: '2000000',
      type: 'sale',
      userRef: 'ksdafiqjwr',
      apn: '377854400',
      acre: 250,
    },
  })

  const [showModal, setShowModal] = useState(false)

  var handleClose = (e) => {
    setShowModal(false)
  }
  var handleSuccess = () => {
    console.log('success')
  }

  function onPropertyClicked(property) {
    setShowModal(true)
    setSelectedProperty(property)
  }

  function handlePropertyMouseOver(property) {}

  function handlePropertyMouseOut() {}
  const navigate = useNavigate()

  function onRanchParcelDelete(parcelId, ranchId, parcelRefId) {
    var endpoint = '/delete_parcel_from_ranch'
    var params = {
      parcel_ref_id: parcelRefId,
      ranch_id: ranchId,
      session_key: localAuth.sessionKey,
    }
    setLoading(true)
    callAPI(endpoint, params)
      .then((res) => {
        setLoading(false)
        if (res.status === 'fail') {
          toast.warn(res.msg)
          setLoading(false)
          return
        } else if (res.status === 'expire') {
          toast.warn(res.msg)
          setLoading(false)
          logout()
          return
        } else {
          let deepCopy = JSON.parse(JSON.stringify(ranchParcels))
          deepCopy[ranchId] = deepCopy[ranchId].filter(
            (parcel) => parcel.id !== parcelId
          )
          setRanchParcels(deepCopy)
          setShowModal(false)
        }
      })
      .catch((e) => {
        toast.warn('Something went wrong. Please try again later.')
        console.log(e)
        setLoading(true)
      })
  }

  function onRanchDelete(ranchId) {
    var endpoint = '/delete_ranch'
    var params = {
      ranch_id: ranchId,
      session_key: localAuth.sessionKey,
    }
    setLoading(true)
    callAPI(endpoint, params)
      .then((res) => {
        setLoading(false)
        if (res.status === 'fail') {
          toast.warn(res.msg)
          setLoading(false)
          return
        } else if (res.status === 'expire') {
          toast.warn(res.msg)
          setLoading(false)
          logout()
          return
        } else {
          invalidateQuery()
          let deepCopy = JSON.parse(JSON.stringify(ranchParcels))
          delete deepCopy[ranchId]
          setRanchParcels(deepCopy)
          let deepCopy2 = ranches.filter((ranch) => ranch.ranch_id !== ranchId)
          setRanches(deepCopy2.slice().sort((a, b) => b.ranch_id - a.ranch_id))
          setShowModal(false)
        }
      })
      .catch((e) => {
        toast.warn('Something went wrong. Please try again later.')
        console.log(e)
        setLoading(true)
      })
  }

  function logout() {
    // TODO : signOut
    localStorage.setItem('auth', JSON.stringify({}))
    setAuth(null)
    setIsLoggedIn(false)
    navigate(
      '/' +
        (searchParams.get('locations')
          ? '?locations=' + searchParams.get('locations')
          : '')
    )
  }

  function onEdit(listingID) {
    navigate(`/edit-listing/${listingID}`)
  }

  async function getRanches() {
    var endpoint = '/get_ranches'
    var params = {
      session_key: localAuth.sessionKey,
    }
    setLoading(true)
    return callAPI(endpoint, params).then((res) => {
      setLoading(false)
      if (res.status === 'fail') {
        setRanches([])
        toast.warn(res.msg)
        return []
      } else if (res.status === 'expire') {
        setRanches([])
        toast.warn(res.msg)
        logout()
        return []
      }
      setCurrentTab('portfolio')
      setRanches(res.ranches.slice().sort((a, b) => b.ranch_id - a.ranch_id))
      return res.ranches.slice().sort((a, b) => b.ranch_id - a.ranch_id)
    })
  }

  async function getParcelsByRanchId(ranchIds) {
    var endpoint = '/get_parcels_by_ranch_id'
    var params = {
      ranch_ids: ranchIds,
      session_key: localAuth.sessionKey,
    }
    return callAPI(endpoint, params).then((res) => {
      if (res.status === 'fail') {
        toast.warn(res.msg)
        return
      } else if (res.status === 'expire') {
        toast.warn(res.msg)
        logout()
        return
      }

      if (Object.keys(res.parcels).length > 0) {
        var ranchFeatures = {}

        res.parcels.features.map(async (feature) => {
          if (!ranchFeatures.hasOwnProperty(feature.properties.ranch_id)) {
            ranchFeatures[feature.properties.ranch_id] = [];
          }
          
          var imgUrls = [feature.properties.sv]
          const hydraScore =
            'hs' in feature.properties
              ? feature.properties['hs'] === 'not yet rated'
                ? 'NR'
                : feature.properties['hs']
              : 'NR'
          const ss =
            'ss' in feature.properties
              ? feature.properties['ss'] === null
                ? 'NR'
                : feature.properties['ss']
              : 'NR'
          ranchFeatures[feature.properties.ranch_id].push({
            type: 'ranch',
            id: feature.id,
            data: {
              name:
                'owner' in feature.properties
                  ? feature.properties['owner']
                  : 'Area of Interest',
              imgUrls: imgUrls,
              timestamp: feature.properties.mod_time,
              address:
                'mail_address' in feature.properties
                  ? feature.properties['mail_address']
                  : 'N/A',
              hydraScore: hydraScore,
              ss: ss,
              regularPrice:
                'price' in feature.properties
                  ? feature.properties['price']
                  : 'mkt_val_bldg' in feature.properties ||
                      'mkt_val_land' in feature.properties
                    ? '$' +
                      (
                        parseFloat(
                          undefinedToZero(feature.properties.mkt_val_bldg)
                        ) +
                        parseFloat(
                          undefinedToZero(feature.properties.mkt_val_land)
                        )
                      ).toString()
                    : 'N/A',
              county:
                'county_name' in feature.properties
                  ? feature.properties['county_name']
                  : null,
              apn:
                'parcel_id' in feature.properties 
                  ? feature.properties['parcel_id']
                  : 'N/A',
              gsa: feature.properties['gsa_info'] 
                  ? feature.properties['gsa_info'].map(gsa => gsa.gsa_name) 
                  : ['N/A'],    
              wd: feature.properties['wd_info'] 
                  ? feature.properties['wd_info'].map(wd => wd.wd_name) 
                  : ['N/A'],        
              acre: parseFloat(feature.properties['acreage_calc']).toFixed(2),
              geolocation: {
                lat: feature.properties['latitude'],
                lng: feature.properties['longitude'],
              },
            },
            feature: feature,
          })
        })
        return ranchFeatures
      }
    })
  }

  const [file, setFile] = useState(null)

  function handleChange(event) {
    setFile(event.target.files[0])
  }

  async function addParcelsFromUpload(data, ranches) {
    return await Promise.all(
      data.ranches_to_create.map(async (ranch_name) => {
        const ranch = ranches.find((item) => item.ranch_name === ranch_name)
        const selectedElements = data.dataframe[ranch_name].features

        const promises = selectedElements.map(async (selectedElement) => {
          return new Promise(async (resolve) => {
            // Extract and transform selectedElement properties
            const {
              properties: {
                parcel_id,
                owner,
                address,
                mail_address,
                county_name,
                mkt_val_land,
                mkt_val_bldg,
                hs,
                ss,
                latitude,
                longitude,
                gsa_info,
                wd_info,
                acreage_calc,
                crop_composition,
                sv,
                soil_composition,
                fld_zone,
                main_crop,
                hydrologic_info,
                acreage_deeded,
              },
              ...remainingFeature
            } = selectedElement

            // Prepare transformed feature with adjustments
            const transformedFeature = {
              ...remainingFeature,
              properties: {
                parcel_id,
                owner,
                address,
                mail_address,
                county_name,
                mkt_val_land,
                mkt_val_bldg,
                hs,
                ss,
                latitude,
                longitude,
                gsa_info,
                wd_info,
                acreage_calc,
                crop_composition,
                sv,
                soil_composition,
                fld_zone,
                main_crop,
                hydrologic_info,
                acreage_deeded,
              },
            }

            // Handle specific transformations
            transformedFeature.properties['mkt_val_land'] = undefinedToZero(
              transformedFeature.properties['mkt_val_land']
            )
            transformedFeature.properties['mkt_val_bldg'] = undefinedToZero(
              transformedFeature.properties['mkt_val_bldg']
            )

            if ('sv' in transformedFeature.properties) {
              const base64Image = btoa(transformedFeature.properties['sv'])
              transformedFeature.properties['sv'] =
                `data:image/png;base64,${base64Image}`
            }

            transformedFeature.properties['soil_properties'] = [['', '']]
            resolve(transformedFeature)
            // // Define API calls as promises
            // const apiCalls = [
            //   callAPI('/get_soils_props_pt', {
            //     lat: selectedElement.properties.latitude,
            //     lon: selectedElement.properties.longitude,
            //     session_key: localAuth.sessionKey,
            //   }),
            // ]

            // // Execute API calls concurrently
            // try {
            //   const [res2] = await Promise.all(apiCalls)
            //   // Handle response from second API call
            //   if (res2.status === 'success') {
            //     const splitSoilProperties = res2.soil.map((soilType) => {
            //       const [name, valueWithUnit] = soilType.split(/:(.+)/)

            //       const nameTrimmed = name.trim()
            //       const valueWithUnitTrimmed = valueWithUnit.trim()

            //       const match = nameTrimmed.match(/\[([^\]]+)\]/)
            //       const unit = match ? match[1] : ''

            //       const firstPart = nameTrimmed.replace(` [${unit}]`, '')
            //       const secondPart =
            //         valueWithUnitTrimmed + (unit ? ' ' + unit : '')

            //       return [firstPart, secondPart]
            //     })
            //     transformedFeature.properties['soil_properties'] =
            //       splitSoilProperties
            //   } else {
            //     transformedFeature.properties['soil_properties'] = [['', '']]
            //   }

            //   // Resolve transformed feature once all processing is done
            //   resolve(transformedFeature)
            // } catch (e) {
            //   setLoading(false)
            //   console.error(e)
            //   resolve() // Skip further processing on error
            // }
          })
        })

        // Wait for all promises in the current ranch_name iteration to resolve
        const transformedFeatures = await Promise.all(promises)
        // Execute this block after all promises for the current ranch_name have resolved
        const apiCalls = transformedFeatures.map((transformedFeature) => {
          const endpoint = '/add_parcel_to_ranch'
          const params = {
            geojson_str: JSON.stringify(transformedFeature),
            ranch_id: ranch.ranch_id,
            session_key: localAuth.sessionKey,
          }

          // Return a promise for each API call
          return new Promise((resolve, reject) => {
            callAPI(endpoint, params)
              .then((existingParcels) => {
                resolve(existingParcels) // Resolve with API response
              })
              .catch((e) => {
                console.error(e)
                reject(e) // Propagate error
              })
          })
        })

        // Execute all API calls for adding parcels to ranch
        const res = await Promise.all(apiCalls)
        // Handle responses from all API calls
        res.forEach((item) => {
          if (item.status === 'fail') {
            toast.warn(item.msg)
          }
        })

        // Example additional API call after completing all ranch operations
        const endpoint = '/get_portfolio_summary'
        const params = {
          ranch_id: ranch.ranch_id.toString(),
          return_update: true,
          session_key: localAuth.sessionKey,
        }

        return callAPI(endpoint, params)
          .then((res) => {})
          .catch((error) => {
            console.error(error)
          })
      })
    )
  }

  function handleSubmit(event) {
    event.preventDefault()

    const sessionKey = localAuth.sessionKey
    //   const url = 'http://localhost:3000/uploadFile';
    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileName', file.name)
    formData.append('session_key', localAuth.sessionKey)
    setLoading(true)
    var BASE_URL =
      document.location.protocol + '//' + document.location.hostname + ':4011'
    if (process.env.REACT_APP_ENV === 'staging')
      BASE_URL = 'https://staging-api.hydrascore.com'
    else if (process.env.REACT_APP_ENV === 'dev')
      BASE_URL = 'https://dev-api.hydrascore.com'
    else if (process.env.NODE_ENV === 'production')
      BASE_URL = 'https://api.hydrascore.com'
    fetch(BASE_URL + '/query_apns_uploadfile/', {
      method: 'POST',
      body: formData,
      headers: {
        authorization: 'Bearer ' + sessionKey,
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false)
        setFile(null)
        // Clear the file input
        if (geomFileRef.current) {
          geomFileRef.current.value = ''
        }
        if (textFileRef.current) {
          textFileRef.current.value = ''
        }
        if (data.status === 'fail') toast.warn(data.msg)
        else {
          getRanches().then((res) => {
            setLoading(true)
            addParcelsFromUpload(data, res).then((res2) => {
              setLoading(false)
              getRanches()
            })
          })
        }
      })
      .catch((error) => {
        setLoading(false)
        setFile(null)
        if (geomFileRef.current) {
          geomFileRef.current.value = ''
        }
        if (textFileRef.current) {
          textFileRef.current.value = ''
        }
        console.error('Error uploading file', error)
      })
  }

  useEffect(() => {
    getRanches()
  }, [])

  async function getAllReports() {
    // Example additional API call after completing all ranch operations
    const endpoint = '/get_all_reports'
    const params = {
      session_key: localAuth.sessionKey,
    }

    return callAPI(endpoint, params)
      .then((res) => {
        if(res.status == 'success'){
          setReports(res.reports)
        }
      })
      .catch((error) => {
        console.error(error)
      })

  }

  async function getAllSummaries() {
    // Example additional API call after completing all ranch operations
    const endpoint = '/get_all_portfolio_summaries'
    const params = {
      session_key: localAuth.sessionKey,
    }

    return callAPI(endpoint, params)
      .then((res) => {
        if(res.status == 'success'){
          setSummaries(res.summaries)
        }
      })
      .catch((error) => {
        console.error(error)
      })

  }
  useEffect(() => {
    if (currentTab === 'portfolio') {
      setLoading(true); // Start loading before async calls
  
      const updatedRanchIds = new Set(ranches.map((r) => r.ranch_id));
  
      setRanchParcels((prevState) => {
        const filteredParcels = Object.keys(prevState)
          .filter((key) => updatedRanchIds.has(Number(key)))
          .reduce((acc, key) => {
            acc[key] = prevState[key];
            return acc;
          }, {});
  
        return {
          ...filteredParcels,
          updateRanchId: 0, // Ensure update trigger
        };
      });
  
      // Get only new ranch IDs
      const newRanchIds = ranches
        .map((r) => r.ranch_id)
        .filter((id) => !(id in ranchParcels));
  
      const promises = [
        getAllReports(),
        getAllSummaries(),
      ];
  
      if (newRanchIds.length > 0) {
        promises.push(
          getParcelsByRanchId(newRanchIds).then((mergedResults) => {
            if (!mergedResults) return; // Handle null/undefined case
  
            for (let key in mergedResults) {
              if (mergedResults.hasOwnProperty(key)) {
                mergedResults[key].sort((a, b) => {
                  const apnA = a.data.apn || '';
                  const apnB = b.data.apn || '';
                  return apnA.localeCompare(apnB, undefined, { numeric: true });
                });
              }
            }
  
            setRanchParcels((prevState) => ({
              ...prevState,
              ...mergedResults,
              updateRanchId: 0,
            }));
          })
        );
      }
  
      Promise.all(promises)
        .catch((error) => console.error('Error processing data:', error))
        .finally(() => setLoading(false)); // Ensure loading is stopped when all are done
    }
  }, [currentTab, ranches]);
  
  

  return (
    <>
      {loading && <Spinner />}
      {popupContent && (
        <InfoPopup
          content={popupContent}
          onClose={() => setPopupContent(null)}
        />
      )}
      <div className="max-w-6xl px-3 mt-6 mx-auto">
        {showModal &&
          (isMobile ? (
            <MobileParcelDetail
              showModal={showModal}
              handleClose={handleClose}
              handleSuccess={handleSuccess}
              property={selectedProperty}
              selectedRanch={selectedRanch}
              setSelectedRanch={setSelectedRanch}
              logout={logout}
              localAuth={localAuth}
              ranches={ranches}
              setRanches={setRanches}
              onRanchParcelDelete={() =>
                onRanchParcelDelete(
                  selectedProperty.id,
                  selectedProperty.feature.properties.ranch_id,
                  selectedProperty.feature.properties.parcel_ref_id
                )
              }
            />
          ) : (
            <ParcelDetail
              showModal={showModal}
              handleClose={handleClose}
              handleSuccess={handleSuccess}
              property={selectedProperty}
              selectedRanch={selectedRanch}
              setSelectedRanch={setSelectedRanch}
              logout={logout}
              localAuth={localAuth}
              ranches={ranches}
              setRanches={setRanches}
              onRanchParcelDelete={() =>
                onRanchParcelDelete(
                  selectedProperty.id,
                  selectedProperty.feature.properties.ranch_id,
                  selectedProperty.feature.properties.parcel_ref_id
                )
              }
            />
          ))}
        <>
          {showAPNSuggestionModal && (
            <APNSuggestionModal
              showAPNSuggestionModal={showAPNSuggestionModal}
              setShowAPNSuggestionModal={setShowAPNSuggestionModal}
            />
          )}
          {!isMobile && (
            <div className="flex justify-center items-center min-h-[120px] space-x-4 m-[10px] relative">
              <UpgradeLayout
                className="rounded-lg"
                title="Upgrade to create ranches in bulk from a list of parcels or geodata files."
                needUpgrade={!enableBulkUpload}
              />
              <div className="w-[50%] flex justify-center items-center shadow-md hover:shadow-xl rounded-md overflow-hidden transition-shadow duration-150 p-4">
                <form
                  className="text-center flex flex-col items-center"
                  onSubmit={handleSubmit}
                >
                  <LuFileText size={'50px'} className="mb-2" />
                  <h1>
                    <strong>Create Ranch from parcel list upload</strong>
                  </h1>
                  <h1>
                    Select{' '}
                    <a
                      style={{ color: 'green', fontWeight: 'bold' }}
                      href="/data/TEST_UPLOAD.txt"
                      download="TEST_UPLOAD.txt"
                    >
                      TXT
                    </a>
                    ,{' '}
                    <a
                      style={{ color: 'green', fontWeight: 'bold' }}
                      href="/data/TEST_UPLOAD.csv"
                      download="TEST_UPLOAD.csv"
                    >
                      CSV
                    </a>
                    ,{' '}
                    <a
                      style={{ color: 'green', fontWeight: 'bold' }}
                      href="/data/TEST_UPLOAD.xls"
                      download="TEST_UPLOAD.xls"
                    >
                      XLS
                    </a>
                    , or{' '}
                    <a
                      style={{ color: 'green', fontWeight: 'bold' }}
                      href="/data/TEST_UPLOAD.xlsx"
                      download="TEST_UPLOAD.xlsx"
                    >
                      XLSX
                    </a>{' '}
                    file formatted with columns as follows:{' '}
                    <strong>ranch_name, county_name, parcel_id</strong>
                  </h1>
                  <h1>(Click on FILETYPE for sample file upload)</h1>
                  <h1>
                    Note: Parcel id (APN) formats vary by county. <br />
                    Click{' '}
                    <a
                      className="cursor-pointer"
                      onClick={() => {
                        setShowAPNSuggestionModal(true)
                      }}
                    >
                      <strong style={{ color: 'skyblue' }}>HERE</strong>
                    </a>{' '}
                    for suggestions.
                  </h1>
                  <div className="flex items-center space-x-2 mt-4">
                    <input
                      ref={textFileRef}
                      type="file"
                      onChange={handleChange}
                      accept=".txt,.xls,.xlsx,.csv,"
                    />
                    <button type="submit">Upload</button>
                  </div>
                </form>
              </div>

              <div className="w-[50%] flex justify-center items-center shadow-md hover:shadow-xl rounded-md overflow-hidden transition-shadow duration-150 p-4">
                <form
                  className="text-center flex flex-col items-center"
                  onSubmit={handleSubmit}
                >
                  <LuFileJson size={'50px'} className="mb-2" />
                  <h1>
                    <strong>Create Ranch from geodata upload</strong>
                  </h1>
                  <h1>
                    Select{' '}
                    <a
                      style={{ color: 'green', fontWeight: 'bold' }}
                      href="/data/geoms.kml"
                      download="geoms.kml"
                    >
                      KML
                    </a>
                    ,{' '}
                    <a
                      style={{ color: 'green', fontWeight: 'bold' }}
                      href="/data/geoms.kmz"
                      download="geoms.kmz"
                    >
                      KMZ
                    </a>{' '}
                    or{' '}
                    <a
                      style={{ color: 'green', fontWeight: 'bold' }}
                      href="/data/geoms.geojson"
                      download="geoms.geojson"
                    >
                      GeoJSON
                    </a>{' '}
                    file formatted with <strong>ranch_name</strong> attributes
                    (if applicable) with associated point, polygon, or
                    multipolygon geometries projected in the EPSG 4326
                    coordinate system
                  </h1>
                  <h1>(Click on FILETYPE for sample file upload)</h1>
                  <div className="flex items-center space-x-2 mt-4">
                    <input
                      ref={geomFileRef}
                      type="file"
                      onChange={handleChange}
                      accept=".geojson,.kml,.kmz,.zip,.json,"
                    />
                    <button type="submit">Upload</button>
                  </div>
                </form>
              </div>
            </div>
          )}
          {ranches.map((ranch) => {
            return (
              <div
                key={ranch.ranch_id}
                className="min-h-[100px] justify-between items-center shadow-md hover:shadow-lg rounded-md transition-shadow duration-150 m-[10px] overflow-x-auto"
              >
                <RanchCardView
                  currentTab={currentTab}
                  ranches={ranches}
                  ranch={ranch}
                  ranchParcels={ranchParcels}
                  setRanchParcels={setRanchParcels}
                  selectedRanch={selectedRanch}
                  setSelectedRanch={setSelectedRanch}
                  updateSummary={updateSummary}
                  setUpdateSummary={setUpdateSummary}
                  logout={logout}
                  localAuth={localAuth}
                  onRanchDelete={onRanchDelete}
                  clearRanchSelection={clearRanchSelection}
                  onEdit={onEdit}
                  onPropertyClicked={onPropertyClicked}
                  handlePropertyMouseOver={handlePropertyMouseOver}
                  handlePropertyMouseOut={handlePropertyMouseOut}
                  isDemoUser={isDemoUser}
                  setPopupContent={setPopupContent}
                  report={reports && reports.length > 0 ? reports.find(report => report.ranch_id === ranch.ranch_id) : {}}
                  ranchSummary={summaries && summaries.length > 0 ? summaries.find(summary => summary.ranch_id === ranch.ranch_id)?.summary : {}}
                />
              </div>
            )
          })}
        </>
      </div>
    </>
  )
}
